var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!vue-loader/lib/style-rewriter?id=data-v-094641ca!postcss-loader!sass-loader?sourceMap!import-glob-loader!vue-loader/lib/selector?type=styles&index=0!./portal-actions-links.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

if(typeof __vue_options__.name === "undefined") {
  __vue_options__.name = "portal-actions-links"
}
module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./app/components/organisms/portal-actions-links/portal-actions-links.vue
// module id = 638
// module chunks = 4